"use client";

export default function Error({ reset }: { reset: () => void }) {
  return (
    <main className="min-h-[60vh] bg-warm-bg px-5 py-20 text-center">
      <h1 className="font-serif text-[30px] text-navy">
        We could not load these jobs
      </h1>
      <p className="mx-auto mt-3 max-w-[520px] text-[15px] leading-7 text-text-muted">
        Something went wrong while loading this employer&apos;s roles. Please
        try again.
      </p>
      <button
        type="button"
        onClick={() => reset()}
        className="mt-6 min-h-[44px] rounded-full bg-navy px-6 py-2 text-[14px] font-semibold text-white transition-colors hover:bg-navy/90"
      >
        Try again
      </button>
    </main>
  );
}
